export const locale = {
  terms_of_use: 'Terms of Use',
  privacy_policy: 'Privacy Policy',
  privacy_practices: 'Privacy Practices',
  accessibility_statement: 'Accessibility Statement',
};
